import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import DriverPerformanceDataGrid from 'components/reports/delivery/DriverPerformanceDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import cloneDeep from 'lodash/cloneDeep';
import {
  convertQueryParamsIntoObject,
  dateFormat,
  convertObjectIntoQueryParams,
} from 'constant/Helpers';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
// selector
import { getIsLoaderOpen } from 'store/app/AppSelectors';
// api
import DeliveryReportService from 'services/reportsService/DeliveryReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const DriverPerformanceReportPage = () => {
  const [data, setData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: dateFormat(new Date()),
    toDate: dateFormat(new Date()),
    companyName: '',
  });
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => getIsLoaderOpen({ state }));
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await DeliveryReportService.getDriverPerformance(params);
      setData(res.data);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Driver Performance Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  const exportFile = async () => {
    try {
      const res = await DeliveryReportService.exportDriverPerformance(inputValues);
      toast.success(res?.data?.message);
    } catch (err) {
      errorLogger('Driver Performance Report Page Export Data Error:', err);
      toast.error('Failed to export the report data!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
      setInputValues(queryObj);
    } else {
      fetchData(inputValues);
    }
  }, []);

  const handleSubmit = async () => {
    const newParams = cloneDeep(inputValues);
    newParams.page = 1;
    const queryString = convertObjectIntoQueryParams(newParams);

    navigate({
      pathname: '/report/DriverPerformanceReport',
      search: queryString,
    });
    fetchData(newParams);
  };

  return (
    <div className="toolbar-table-style quick-actions-table">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        title="Driver Performance"
        company
        defaultDate
        hasExport
        handleExport={exportFile}
      />
      {!isLoading && <DriverPerformanceDataGrid data={data} params={inputValues} />}
    </div>
  );
};

export default DriverPerformanceReportPage;
